import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  containerStyle: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  textContainerStyle: {
    flex: 1,
    marginLeft: 11,
  },
  titleStyle: {
    fontSize: 18.7,
    lineHeight: 25,
  },
  descriptionStyle: {
    fontSize: 14.6,
    lineHeight: 18.7,
    marginTop: 16,
    marginLeft: 43,
  },
});
